import React, { useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { minifyCSS } from '../Conversion/Minifiers';
import RandomContent from '../Components/RandomContent';

const CssMinifier = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

    const handleConversion = () => {
        const { minified, isError } = minifyCSS(inputData);
        setOutputData(minified);
        setIsError(isError);
    };

    return (
           <><div>
            <Header />

            <RandomContent />

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">CSS Minifier</a></h4>
                                    <p>Use our free CSS Minifier tool to compress your CSS code by removing whitespace, comments, and extra characters. Ideal for reducing file size and improving website performance. Fast, secure, and 100% client-side.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="thumb">
                                    <Inputs
                                        value={inputData}
                                        setValue={(val) => {
                                            setInputData(val);
                                            setIsError(false); // Reset error on change
                                        }}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        isError={isError}
                                        lineCol={inputLnCol}
                                        setLineCol={setInputLnCol}
                                        readOnly={false}
                                        idPrefix="input" />
                                </div>
                            </div>
                        </div>

                        {/* Controls */}
                        <div
                            className="w3-col m2"
                            style={{
                                flex: 2,
                                display: 'flex',
                                justifyContent: 'center', // horizontal center
                                alignItems: 'center', // vertical center
                            }}
                        >
                            <button
                                className="default-btn icon four" onClick={handleConversion}>
                                <i className="ri-exchange-line"></i>
                                Convert
                            </button>
                        </div>

                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="1200">
                                <div className="thumb">
                                    <Output
                                        value={outputData}
                                        lineCol={outputLnCol}
                                        setLineCol={setOutputLnCol}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        idPrefix="output" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

            <Footer />
        </>
    );
};

export default CssMinifier;